import Controller from "./sideGrid.controller";
import template from "./sideGrid.html";

const sideGrid = {
  template,
  controller: Controller,
  bindings: {
    gridTitle: "@",
    list: "<",
  },
};

export default sideGrid;



// WEBPACK FOOTER //
// ./src/components/sideGrid/sideGrid.component.js